<template>
  <div class="ui segment" :class="{ 'basic fitted': !submitted, 'raised green': isCorrect && submitted, 'raised red': !isCorrect && submitted }">
    <div v-if="submitted">
      <span class="ui bold text" :class="{ 'green': isCorrect, 'red': !isCorrect }">{{ gradeText }}</span>
    </div>
    <div class="ui basic fitted segment right floated">
      <span class="ui bold blue text">{{ `${index + 1} of ${length}` }}</span>
    </div>
    <div class="ui basic fitted segment">
      <span class="ui bold blue text">{{ 'Q: ' }}</span>
      <span tabindex="0" v-html="question.text"></span>
    </div>
    <div class="ui basic segment">
      <div v-for="(choice, index) in question.choices" :key="index" class="ui basic fitted segment">
        <div
          v-if="question.type === 'truefalse'"
          class="ui green radio checkbox padded"
          @click="changeRadio(index)"
          @keyup="(e) => keyupRadio(e, index)"
        >
          <input
            type="radio"
            :name="question.id"
            :checked="choice.selected"
            :value="choice.selected"
            :disabled="submitted"
          />
          <label v-html="choice.text"></label>
        </div>
        <div
          v-if="question.type === 'multchoice'"
          class="ui green checkbox padded"
          @click="changeCheckbox(index)"
          @keyup="(e) => keyupCheckbox(e, index)"
        >
          <input
            type="checkbox"
            :checked="choice.selected"
            :value="choice.selected"
            :disabled="submitted"
          />
          <label v-html="choice.text"></label>
        </div>
      </div>
    </div>
    <div v-if="!submitted" class="ui divider" />
  </div>
</template>

<script>
export default {
  name: 'Question',
  props: ['question', 'index', 'length', 'submitted'],
  data() {
    return {
      correct: [],
    };
  },
  computed: {
    isCorrect() {
      if (this.submitted) {
        this.question.choices.forEach(c => {
          if (c.type === c.selected) {
            this.correct.push(c);
          }
        });
        return this.correct.length === this.question.choices.length;
      } else return false;
    },
    gradeText() {
      if (this.isCorrect) {
        return 'Correct';
      }
      if (!this.isCorrect && this.correct.length > 0 && this.question.type === 'multchoice') {
        return 'Partially Correct';
      } else return 'Incorrect';
    },
  },
  methods: {
    keyupRadio(e, index) {
      if ([13, 32, 38, 40].includes(+e.keyCode)) {
        this.changeRadio(index);
      }
    },
    keyupCheckbox(e, index) {
      if ([13, 32].includes(+e.keyCode)) {
        this.changeCheckbox(index);
      }
    },
    changeRadio(index) {
      if (!this.submitted) {
        this.question.choices.forEach((c, i) => {
          c.selected = (i === index);
        });
        this.$emit('select', this.question);
      }
    },
    changeCheckbox(index) {
      if (!this.submitted) {
        this.question.choices[index].selected = !this.question.choices[index].selected;
        const selected = this.question.choices.find(c => c.selected === true);
        if (!selected) {
          this.$emit('remove', this.question);
        } else {
          this.$emit('select', this.question);
        }
      }
    },
    reset() {
      this.correct = [];
      $('.ui.checkbox').checkbox('uncheck');
    },
  },
  mounted() {
    $('.ui.checkbox').checkbox();
  },
};
</script>
<style lang="less" scoped>
  .ui.checkbox:focus-within {
    border: solid black 1px;
  }
</style>
